import { BaseService } from "@/script/core/service/BaseService";
import { Success, Failure } from "@/script/core/service/DataService";

export class TemplateService extends BaseService {
    public loadContent(id: number): Promise<any> {
        return super.get("/api/cms/template/content/load", { id });
    }

    public saveContent(id: number, content: string): Promise<any> {
        return super.postText("/api/cms/template/content/save/" + id, content);
    }

    public loadListByType(type: string): Promise<any> {
        return super.get("/api/cms/template/list/query/type", { type });
    }
}
